import { Link } from "react-router-dom";

export default function PublicHeader() {
  return (
    <header className="sticky top-0 z-30 bg-white/85 backdrop-blur-xl border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="public-brand-link">
            <img
              src="/images/brand-logo.png"
              alt="Centro de Performance Farmacêutica"
              width="44"
              height="44"
              className="w-11 h-11 object-contain"
              data-testid="public-brand-logo"
            />
            <div className="leading-tight">
              <div className="brand-wordmark font-bold text-[15px] text-primary uppercase">Centro de Performance</div>
              <div className="text-[10px] text-gold overline tracking-[0.22em]">Farmacêutica</div>
            </div>
          </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/agendamento" className="text-foreground hover:text-primary transition-colors font-semibold" data-testid="nav-agendar">Agendar</Link>
          <a href="/#protocolos" className="text-foreground hover:text-primary transition-colors" data-testid="nav-protocolos">Protocolos</a>
          <a href="/#como-funciona" className="text-foreground hover:text-primary transition-colors" data-testid="nav-como-funciona">Como funciona</a>
          <a href="/#planos" className="text-foreground hover:text-primary transition-colors" data-testid="nav-planos">Planos</a>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/login" className="text-sm font-medium hover:text-primary transition-colors" data-testid="public-login-link">Entrar</Link>
          <Link
            to="/cadastro"
            className="inline-flex items-center justify-center rounded-sm bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:bg-primary/90 transition-colors"
            data-testid="public-cta-register"
          >
            Começar agora
          </Link>
        </div>
      </div>
    </header>
  );
}
